import React from 'react'
import { Link } from 'gatsby';
const Jumbo = () => (
      <Link to='/business-ideas'>
      <div className="p-5 shadow-4 rounded-5" style={{textAlign:'center',backgroundColor: 'hsl(0, 0%, 94%)'}}>
          <h3><b>103 Business Ideas and Resources</b>   you need to Start an Profitable Online Business</h3>
          <br/>
          <p>
            This is a simple hero unit, a simple jumbotron-style component for calling extra
          </p>
        </div>
      </Link>
      );
export default Jumbo;